import {
    Box,
    Grid,
    IconButton,
    Modal,
    Stack,
    TableCell,
    Typography,
    Button,
    CircularProgress,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Path, UseFormReturn, useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
//
import { FormButton } from '../../componets/form/formButton';
import { paths } from '../../config';
import { useContextGlobal } from '../../context/ContextGlobal';
import { useToast } from '../../context/ToastContext';
import api from '../../services/api';
import { handleExceptionMessage } from '../../util/handleExceptionAxios';
import { message } from '../../util/handleMessages';
import { FormInputProps } from '../../componets/form/formInterfaces';
import IDescription from '../../util/interfaces/description';
import IName from '../../util/interfaces/name';
import { useAuth } from '../../context/AuthContext';
import RenderForm from '../../componets/form/renderForm';
import { momentZoneToDate } from '../../util/dateUtil';
import { ColumnDef } from '@tanstack/react-table';
import { IconComponent, icons } from '../../componets/icons';
import { useWindowSize } from '../../util/responsiveness';
import { FormInputText } from '../../componets/form/formInputText';
import { TableGeneric } from '../../componets/table';
import { formatNumber } from '../../util/infoFormat';
import FormComplete from '../../componets/form/formComplete';
import { ImperativeHandleAccessedByParentComponent } from '../../componets/interfaces/formProps';
import * as ImplEnum from '../../communs/enums/generic-enum';

interface IFormInput {
    code: string;
    dateSpend: Date | undefined;
    customer?: IDescription;
    user?: IDescription;
    processNumber: string;
    itemExpenses: ItemExpense[];
    generateInstallments?: boolean;
}

interface ItemExpense {
    originExpenditure: {
        id: string;
        description: string;
    };
    description: string;
    quantity: number;
    itemValue: number;
}

interface IUpdateSearchByProcessNumber {
    description: string;
    keyField: 'legalProcess';
}

interface ModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    index: number;
    setIndex: (index: number) => void;
    getValues: any;
    append: any;
    update: any;
    width: number;
    inputs: FormInputProps<ItemExpense>[];
    useFormItems: UseFormReturn<ItemExpense>;
}

interface ModalOriginTypeProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    setValue: any;
    width: number;
}

interface ModalProcessProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    width: number;
    handleClick: (data: DataProcess) => void;
}

interface DataProcess {
    customer?: IName;
    processNumber?: string;
}

const enumInstances = {
    phaseLegalProcessOptionsInstance: new ImplEnum.GenericEnum(
        ImplEnum.phaseLegalProcessOptions,
    ),
};

const Form: React.FC<{ settings: any }> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const params = useParams<'id' | any>();
    const history = useHistory();
    const [width] = useWindowSize();
    const [openProcessModal, setOpenProcessModal] = useState(false);
    const [totalValueRef, setTotalValueRef] = React.useState<number>();
    const [openModalOriginType, setOpenModalOriginType] = useState(false);

    const { user } = useAuth();

    const nameFields = 'itemExpenses';

    const defaultValues = React.useMemo<any>(() => {
        return {
            user: {
                id: user.sub,
                description: user.name,
            },
            dateSpend: momentZoneToDate(undefined),
            generateInstallments: !params?.id,
        };
    }, [user, params]);

    const calcTotal = ({ data }: { data: any }) => {
        if (data && Array.isArray(data)) {
            const total = data.reduce((accumulator: number, item: any) => {
                const quantity = Number(item.quantity);
                const itemValue = Number(item.itemValue);
                return accumulator + quantity * itemValue;
            }, 0);
            return total;
        }
        return 0;
    };

    const columnsTable = React.useMemo<ColumnDef<ItemExpense>[]>(
        () => [
            {
                id: 'originExpenditure',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Tipo de origem
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    row.id,
                                    nameFields,
                                )
                            }>
                            {row.original?.originExpenditure.description}
                        </TableCell>
                    );
                },
            },
            {
                accessorKey: 'description',
                cell: (cell: any) => {
                    return (
                        <TableCell
                            align="left"
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    cell.row.id,
                                    nameFields,
                                )
                            }>
                            {cell.row.original.description}
                        </TableCell>
                    );
                },
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Descrição
                    </TableCell>
                ),
            },
            {
                id: 'user',
                header: (info: any) => {
                    return (
                        <TableCell align={'left'} padding={'normal'}>
                            Valor
                        </TableCell>
                    );
                },
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    row.id,
                                    nameFields,
                                )
                            }>
                            {formatNumber(row.original?.itemValue)}
                        </TableCell>
                    );
                },
            },
            {
                id: 'user',
                header: (info: any) => {
                    return (
                        <TableCell align={'left'} padding={'normal'}>
                            Quantidade
                        </TableCell>
                    );
                },
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    row.id,
                                    nameFields,
                                )
                            }>
                            {row.original?.quantity}
                        </TableCell>
                    );
                },
            },
            {
                id: 'user',
                header: (info: any) => {
                    return (
                        <TableCell align={'left'} padding={'normal'}>
                            Sub total
                        </TableCell>
                    );
                },
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    row.id,
                                    nameFields,
                                )
                            }>
                            {formatNumber(
                                row.original?.itemValue *
                                    row.original?.quantity,
                            )}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <IconButton
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    row.id,
                                    nameFields,
                                )
                            }>
                            <IconComponent icon={icons.ModeEdit} />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                refForm?.current?.handleDeleteItemTable(
                                    row.id,
                                    nameFields,
                                );
                            }}>
                            <IconComponent icon={icons.Delete} />
                        </IconButton>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    const inputsForm = React.useMemo<FormInputProps<any>[]>(
        () => [
            {
                typeInput: 'component',
                name: 'code',
                control: null,
                label: 'Código',
                md: 12,
                xs: 12,
                componentProps: {
                    componentData: data => (
                        <Typography
                            sx={{ flex: '1 1 100%', fontSize: '1rem' }}
                            variant="h6"
                            id="tableTitle"
                            component="div">
                            {data?.code ? `Código: ${data['code']}` : ''}
                        </Typography>
                    ),
                    conditionRender: params && params.id,
                },
            },
            {
                typeInput: 'text',
                name: 'processNumber',
                control: null,
                label: 'Número do processo',
                loadingAutocomplete: false,
                md: 3,
                xs: 12,
                actionOnInput: {
                    action: () => {
                        setOpenProcessModal(true);
                    },
                    iconProps: {
                        icon: icons.Search,
                    },
                    textTooltip: 'Pesquise aqui o número do processo',
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'customer',
                control: null,
                label: 'Cliente',
                setValue: null,
                md: 6,
                xs: 12,
                query: (value: string) => `customer?name=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'autocomplete',
                name: 'user',
                control: null,
                label: 'Advogado',
                setValue: null,
                md: 3,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo é obrigatório',
                    },
                ],
                query: (value: string) => `users?name=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'date',
                name: 'dateSpend',
                control: null,
                label: 'Data',
                setValue: null,
                md: 3,
                xs: 12,
                placeholder: 'dd/mm/aaaa hh:mm',
                rules: {
                    validate: (value: any) => {
                        if (value && String(value) === 'Invalid Date') {
                            return 'A data está em um formato inválido';
                        }
                    },
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo data é obrigatório',
                    },
                ],
            },
            {
                typeInput: 'checkbox',
                name: 'generateInstallments',
                control: null,
                label: 'Gerar parcelas',
                md: 3,
                xs: 12,
            },
            {
                typeInput: 'subForm',
                name: nameFields,
                control: null,
                label: 'Itens',
                md: 12,
                xs: 12,
                defaultValues: {
                    quantity: 1,
                },
                dto: data => {
                    if (
                        !data[nameFields] ||
                        (Array.isArray(data[nameFields]) &&
                            data[nameFields].length === 0)
                    ) {
                        delete data[nameFields];
                    }
                    return data;
                },
                dataTable: {
                    propsTable: {
                        columns: columnsTable,
                        data: [],
                        minWidth: 600,
                    },
                    inputs: [
                        {
                            typeInput: 'autocomplete',
                            name: 'originExpenditure',
                            control: null,
                            label: 'Tipo de origem',
                            setValue: null,
                            md: 6,
                            xs: 12,
                            rules: {
                                required: true,
                            },
                            messagesError: [
                                {
                                    type: 'required',
                                    message:
                                        'O campo tipo de origem é obrigatório',
                                },
                            ],
                            actionOnInput: {
                                action: () => {
                                    setOpenModalOriginType(true);
                                },
                                iconProps: {
                                    icon: icons.AddCircle,
                                },
                                textTooltip: 'Adicionar tipo de origem',
                            },
                            query: (value: string) =>
                                `origin-expenditure?originExpenditure.description=${value}`,
                            activeDebounce: true,
                        },
                        {
                            typeInput: 'text',
                            name: 'description',
                            control: null,
                            label: 'Descrição',
                            loadingAutocomplete: false,
                            md: 6,
                            xs: 12,
                            messagesError: [
                                {
                                    type: 'required',
                                    message: 'O campo descrição é obrigatório',
                                },
                            ],
                        },
                        {
                            typeInput: 'number',
                            name: 'quantity',
                            control: null,
                            label: 'Quantidade',
                            md: 6,
                            xs: 12,
                            decimalScale: 0,
                            rules: {
                                validate: (value: number) => {
                                    if (value && value < 0) {
                                        return 'O campo quantidade não pode ser menor que zero';
                                    }
                                },
                            },
                            defaultValue: 1,
                        },
                        {
                            typeInput: 'number',
                            name: 'itemValue',
                            control: null,
                            label: 'Valor',
                            md: 6,
                            xs: 12,
                            decimalScale: 2,
                            rules: {
                                validate: (value: number) => {
                                    if (value && value < 0) {
                                        return 'O campo valor não pode ser menor que zero';
                                    }
                                },
                            },
                        },
                    ] as FormInputProps<ItemExpense>[],
                },
            },
        ],
        [columnsTable, params],
    );

    const handleDeleteItemTable = async (index: number) => {};

    // const submit = async (data: any, e: any) => {
    //     e.preventDefault();
    //     try {
    //         setOpenLoading(true);

    //         for (const input of inputsForm) {
    //             if (!input?.dto) {
    //                 continue;
    //             }
    //             data = input.dto(data);
    //         }

    //         let response = { data: { id: null } };
    //         if (params && params.id) {
    //             response = await api.patch(
    //                 `${settings.apiPath}/${params.id}`,
    //                 data,
    //             );
    //         } else {
    //             response = await api.post(settings.apiPath, data);
    //         }
    //         addToast({
    //             type: 'success',
    //             title: message.success.save,
    //             description: '',
    //         });
    //         setOpenLoading(false);
    //         reset(defaultValues);

    //         if (data.generateInstallments) {
    //             const redirect = Object.keys(paths).find(
    //                 k => k === 'additionalExpense',
    //             );
    //             history.push(
    //                 `${paths.invoiceDetailRegister}/${response.data.id}/additionalExpense/${data.user.id}/${redirect}`,
    //             );
    //         } else {
    //             history.goBack();
    //         }
    //     } catch (error) {
    //         setOpenLoading(false);
    //         const messagesResponse = handleExceptionMultipleMessages(error);
    //         for (const messageResponse of messagesResponse) {
    //             addToast({
    //                 type: 'error',
    //                 title: message.error.save,
    //                 description: messageResponse,
    //             });
    //         }
    //     }
    // };

    const implSetValueData = React.useCallback(
        (data: IFormInput) => {
            for (const input of inputsForm) {
                if (input?.setData) {
                    refForm?.current?.setValue(
                        input.name as Path<IFormInput>,
                        input.setData(data),
                    );
                    continue;
                }

                refForm?.current?.setValue(
                    input.name as Path<IFormInput>,
                    data[input.name as keyof IFormInput],
                );
            }
            const total = data.itemExpenses.reduce(
                (accumulator: number, item: ItemExpense) => {
                    const quantity = Number(item.quantity);
                    const itemValue = Number(item.itemValue);
                    return accumulator + quantity * itemValue;
                },
                0,
            );
            setTotalValueRef(total);
        },
        [inputsForm],
    );

    function getTotal(data: IFormInput) {
        if (!Array.isArray(data?.itemExpenses)) {
            return 0;
        }
        return data.itemExpenses.reduce(
            (accumulator: number, item: ItemExpense) => {
                const quantity = Number(item.quantity);
                const itemValue = Number(item.itemValue);
                return accumulator + quantity * itemValue;
            },
            0,
        );
    }

    function callbackSuccess(response: any) {
        const totalValue = getTotal(response?.data || null);
        if (params?.id && totalValue !== totalValueRef) {
            response.data.generateInstallments = true;
        }

        if (response.data?.generateInstallments && totalValue > 0) {
            const redirect = Object.keys(paths).find(
                k => k === 'additionalExpense',
            );
            history.push(
                `${paths.invoiceDetailRegister}/${
                    response.data.id
                }/additionalExpense/${
                    refForm?.current?.watch('user')?.id
                }/${redirect}`,
            );
        } else {
            history.push(`${paths.additionalExpense}?`);
        }
    }

    const handleClick = React.useCallback(
        (data: DataProcess) => {
            setTimeout(() => {
                refForm?.current?.setValue('processNumber', data.processNumber);
                refForm?.current?.setValue('customer', data.customer);
                setOpenProcessModal(false);
            }, 200);
        },
        [refForm],
    );

    return (
        <>
            <ModalSaveOriginType
                open={openModalOriginType}
                setOpen={setOpenModalOriginType}
                width={width}
                setValue={
                    refForm?.current?.dynamicUseFormToFieldArrays[nameFields]
                        ?.setValue
                }
            />
            <ModalProcess
                open={openProcessModal}
                setOpen={setOpenProcessModal}
                handleClick={handleClick}
                width={width}
            />
            <FormComplete
                defaultValues={defaultValues}
                inputsForm={[...inputsForm]}
                ref={refForm}
                settings={settings}
                configDataFooter={{
                    dataFooter: calcTotal,
                    nameFields,
                }}
                implSetValueData={implSetValueData}
                callbackSuccess={callbackSuccess}
            />
        </>
    );
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: '4px',
};

function ModalSaveOriginType({
    open,
    setOpen,
    width,
    setValue,
}: ModalOriginTypeProps) {
    const { addToast } = useToast();
    const { setOpenLoading } = useContextGlobal();

    const defaultValues = {
        description: '',
    };

    const styleModal = {
        ...style,
    };

    if (width <= 800) {
        styleModal.width = '90%';
    }

    const useFormModal = useForm<any>({
        defaultValues: defaultValues,
    });
    const controlItems = useFormModal.control;
    const handleSubmit = useFormModal.handleSubmit;
    const reset = useFormModal.reset;

    const inputsForm: FormInputProps<any>[] = [
        {
            typeInput: 'text',
            name: 'descriptionOriginType',
            control: controlItems,
            label: 'Descrição',
            loadingAutocomplete: false,
            md: 12,
            xs: 12,
            rules: {
                required: true,
            },
            autoFocus: true,
            messagesError: [
                {
                    type: 'required',
                    message: 'O campo descrição é obrigatório',
                },
            ],
            dto: data => {
                data.description = data.descriptionOriginType;
                return data;
            },
        },
    ];

    const handleClose = () => {
        setOpen(false);
        reset(defaultValues);
    };

    const submitItem = async (data: any) => {
        setOpenLoading(true);
        try {
            for (const input of inputsForm) {
                if (!input?.dto) {
                    continue;
                }
                data = input.dto(data);
            }
            const response = await api.post('origin-expenditure', data);

            if (setValue) {
                setValue('originExpenditure', response.data);
            }
            addToast({
                type: 'success',
                title: message.success.save,
                description: 'Tipo de origem salvo',
            });
            handleClose();
        } catch (error: any) {
            const messageResponse = handleExceptionMessage(error);
            addToast({
                type: 'error',
                title: message.error.save,
                description: messageResponse,
            });
        }
        setOpenLoading(false);
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} component={'div'}>
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2">
                        Adicionar tipo de origem
                    </Typography>
                    <form
                        onSubmit={handleSubmit((data: any) =>
                            submitItem(data),
                        )}>
                        <Grid sx={{ pt: 2, pb: 2 }} container spacing={2}>
                            <RenderForm inputsForm={inputsForm} />
                        </Grid>
                        <span />
                        <Stack spacing={1} direction="row">
                            <FormButton
                                label={'Salvar e aplicar'}
                                typeButton={'submit'}
                            />
                            <Button variant="outlined" onClick={handleClose}>
                                Cancelar
                            </Button>
                        </Stack>
                    </form>
                </Box>
            </Modal>
        </div>
    );
}

const styleModalProcess = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1000px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: '4px',
};

function ModalProcess({
    open,
    setOpen,
    width,
    handleClick,
}: ModalProcessProps) {
    const { control } = useForm<any>({
        defaultValues: { findByProcessNumber: '' },
    });
    const [focus, setFocus] = useState(true);
    const { addToast } = useToast();

    const [data, setData] = useState<DataProcess[]>([]);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const styleModal = {
        ...styleModalProcess,
    };

    if (width <= 800) {
        styleModal.width = '90%';
    }

    const columnsTable = React.useMemo<ColumnDef<DataProcess>[]>(
        () => [
            {
                id: 'processNumber',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Número processo
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() => handleClick(row.original)}>
                            {row.original?.processNumber}
                        </TableCell>
                    );
                },
            },
            {
                accessorKey: 'customer',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Cliente
                    </TableCell>
                ),
                cell: (cell: any) => {
                    return (
                        <TableCell
                            align="left"
                            onClick={() => handleClick(cell.row.original)}>
                            {cell.row.original.customer.name}
                        </TableCell>
                    );
                },
            },
            {
                id: 'situation',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Fase
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            key={row.id}
                            align="left"
                            onClick={() => handleClick(row.original)}>
                            {
                                enumInstances.phaseLegalProcessOptionsInstance.getObject(
                                    row.original.phase,
                                )?.description
                            }
                        </TableCell>
                    );
                },
            },
        ],
        [],
    );

    const searchSettings = {
        legalProcess: {
            query: (value: string) =>
                `legal-process/free?legalProcess.processNumber=${value}`,
            setOptions: (options: DataProcess[]) => {
                setData(options);
            },
        },
    };

    const updateAutocomplete = async ({
        description,
        keyField,
    }: IUpdateSearchByProcessNumber) => {
        if (description && description.length > 0) {
            setLoading(true);
            try {
                const response = await api.get(
                    searchSettings[keyField].query(description),
                );
                searchSettings[keyField].setOptions(response.data.data);
            } catch (error: any) {
                const messageResponse = handleExceptionMessage(error);
                addToast({
                    type: 'error',
                    title: message.error.selectAll,
                    description: messageResponse,
                });
            }
            setLoading(false);
        }
    };

    const handleOnKeyPress = (data: any) => {
        if (data.charCode === 13) {
            let keyField: 'legalProcess' = 'legalProcess';
            updateAutocomplete({ description: data.target.value, keyField });
            setFocus(false);
        }
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} component={'div'}>
                    <div className="header-modal" style={{ marginBottom: 8 }}>
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2">
                            {'Pesquisa de processos'}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <IconComponent icon={icons.Close} />
                        </IconButton>
                    </div>
                    <Grid container spacing={2}>
                        <Grid item md={12} xs={12}>
                            <FormInputText
                                name={'findByProcessNumber'}
                                control={control}
                                label={'Número do processo'}
                                handleOnKeyPress={handleOnKeyPress}
                                autoFocus={focus}
                            />
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: loading
                                        ? 'center'
                                        : 'flex-start',
                                    justifyContent: 'center',
                                    minHeight: 400,
                                }}>
                                {loading ? (
                                    <CircularProgress color="inherit" />
                                ) : (
                                    <TableGeneric
                                        data={data}
                                        columns={columnsTable}
                                        minWidth={650}
                                    />
                                )}
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}

export default Form;
